module.exports = __webpack_public_path__ + "img/banner_plate.d83e8c1e.png";